import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/v1/kubernetes/clusters/:clusterId/cost-report', () => {
    return HttpResponse.json({});
  }),
  http.post(
    '/api/v1/cost-reports/clusters/:clusterId/reporting-capabilities',
    () => {
      return HttpResponse.json({});
    }
  ),
];

export default handlers;
